import { useRef } from 'react';
import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import HeroSection from './sections/HeroSection/HeroSection';
import SleepWellSection from './sections/SleepWellSection/SleepWellSection';
import FeelWellSection from './sections/FeelWellSection/FeelWellSection';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <SleepWellSection />
      <FeelWellSection />
    </div>
  );
};

export default Home;
